import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
const WHATSAPP_LINK = 'https://wa.me/message/TNDFTC7M6U4AI1';
export function Hero() {
  return <section className="relative pt-32 pb-20 px-6 overflow-hidden flex flex-col items-center text-center min-h-[90vh] justify-center" data-id="element-24">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-25" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto relative z-10" data-id="element-26">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-brand-gold/30 bg-brand-gold/5 text-brand-goldLight text-sm font-medium mb-8" data-id="element-27">
          <span className="w-2 h-2 rounded-full bg-brand-gold animate-pulse" data-id="element-28" />
          De Cero a E-commerce by Luisina Wuerich
        </div>

        <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-6 leading-[1.1]" data-id="element-29">
          Dejá de depender de la suerte o de{' '}
          <span className="gold-gradient-text" data-id="element-30">“algún día empiezo”</span>.
        </h1>

        <p className="text-xl md:text-2xl text-brand-muted mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-31">
          En esta mentoría vas a construir tu tienda online desde cero y
          aprender el sistema para vender con estrategia, contenido y anuncios.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12 text-left" data-id="element-32">
          <div className="space-y-3" data-id="element-33">
            {['No necesitás experiencia previa.', 'No necesitás tener todo el día libre.', 'No tenés que hacerlo sola.', 'Vas a tener una guía clara para avanzar paso a paso.'].map((bullet, i) => <motion.div initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4 + i * 0.1
          }} key={i} className="flex items-center gap-3 text-brand-text/90" data-id="element-34">
                <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-35" />
                <span data-id="element-36">{bullet}</span>
              </motion.div>)}
          </div>
        </div>

        <motion.a whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-brand-gold text-brand-darker px-8 py-4 rounded-full text-lg font-bold hover:bg-brand-goldLight transition-colors w-full sm:w-auto shadow-[0_0_30px_rgba(212,175,55,0.3)]" data-id="element-37">
          Quiero empezar mi e-commerce
          <ArrowRight className="w-5 h-5" data-id="element-38" />
        </motion.a>
      </motion.div>
    </section>;
}